var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade demand-message-modal",
      attrs: {
        id: "messageModal",
        "data-focus": "false",
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-scrollable" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "flex-container" }, [
              _c("div", { staticClass: "box" }, [_vm._t("header")], 2),
              _c(
                "div",
                { staticClass: "box close-icon" },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#808080", name: "close-outline" },
                    on: { click: _vm.closeModal },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "result-list",
                staticStyle: { "margin-top": "16px" },
              },
              [
                _c("div", { staticClass: "state-btn-wrap" }, [
                  _c(
                    "a",
                    {
                      staticClass: "success",
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.messageState = "successful"
                        },
                      },
                    },
                    [
                      _c("eva-icon", {
                        attrs: {
                          fill: "#5380f7",
                          name: "checkmark-circle-2-outline",
                        },
                      }),
                      _vm._v(" 成功 "),
                      _c("span", [_vm._v(_vm._s(_vm.successfulList.length))]),
                      _vm._v(" 筆 "),
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "failure",
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.messageState = "failed"
                        },
                      },
                    },
                    [
                      _c("eva-icon", {
                        attrs: {
                          fill: "#df2e2e",
                          name: "close-circle-outline",
                        },
                      }),
                      _vm._v(" 失敗 "),
                      _c("span", [_vm._v(_vm._s(_vm.failedList.length))]),
                      _vm._v(" 筆 "),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "result-person-list",
                    class: { failed: _vm.messageState === "failed" },
                  },
                  [
                    _vm.messageState === "successful"
                      ? _c(
                          "div",
                          _vm._l(_vm.successfulList, function (success, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "person" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/head2.png"),
                                    alt: "",
                                  },
                                }),
                                _vm._v(" " + _vm._s(success) + " "),
                              ]
                            )
                          }),
                          0
                        )
                      : _c(
                          "div",
                          _vm._l(_vm.failedList, function (fail, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "person" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/head2.png"),
                                    alt: "",
                                  },
                                }),
                                _vm._v(" " + _vm._s(fail) + " "),
                              ]
                            )
                          }),
                          0
                        ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }